import {ExportOption} from "./exportOption"

export enum ExportFileType {
    CSV = "CSV",
    XLSX = "XLSX",
    TSV = "TSV",
}

interface IExportFileTypeProperties {
    label: string
    fileExtension: string
    availableExportOptions: ExportOption[]
}

export const ExportFileTypeProperties: {
    [key in ExportFileType]: IExportFileTypeProperties
} = {
    [ExportFileType.CSV]: {
        label: "Comma Separated Values",
        fileExtension: "csv",
        availableExportOptions: [
            ExportOption.transposeValues,
            ExportOption.exportStatus,
            ExportOption.exportAllValueTypes,
            ExportOption.replaceValuesOf,
        ],
    },
    [ExportFileType.XLSX]: {
        label: "Excel 2007-Worksheet",
        fileExtension: "xlsx",
        availableExportOptions: [
            ExportOption.transposeValues,
            ExportOption.addComments,
            ExportOption.exportStatus,
            ExportOption.exportAllValueTypes,
            ExportOption.replaceValuesOf,
        ],
    },
    [ExportFileType.TSV]: {
        label: "Tabulator separated values",
        fileExtension: "txt",
        availableExportOptions: [
            ExportOption.transposeValues,
            ExportOption.exportStatus,
            ExportOption.exportAllValueTypes,
            ExportOption.replaceValuesOf,
        ],
    },
}

export const getDescription = (exportFileType: ExportFileType): string => {
    return `${ExportFileTypeProperties[exportFileType].label} (*.${ExportFileTypeProperties[exportFileType].fileExtension})`
}

export const getAvailableExportOptions = (
    exportFileType: ExportFileType
): ExportOption[] => {
    return ExportFileTypeProperties[exportFileType].availableExportOptions
}
